import { useState, useMemo } from "react";
import { bandFor, tenureYears, GREY } from "@/lib/orgUtils";
import { ChevronDown } from "lucide-react";

export default function Legend({ employees, colorConfig }) {
  const [open, setOpen] = useState(true);
  const counts = useMemo(() => {
    const active = employees.filter((e) => e.status === "active");
    const res = (colorConfig?.bands || []).map((b) => ({ ...b, count: 0 }));
    let missing = 0;
    active.forEach((e) => {
      if (tenureYears(e.date_of_joining) == null) { missing++; return; }
      const b = bandFor(e.date_of_joining, colorConfig.bands);
      const r = res.find((x) => x.label === b?.label);
      if (r) r.count++;
    });
    return { bands: res, missing };
  }, [employees, colorConfig]);

  if (!colorConfig?.enabled) return null;
  return (
    <div className="absolute bottom-4 left-4 z-30 rounded-xl bg-white/85 backdrop-blur-xl border border-white/50 shadow-lg overflow-hidden" data-testid="tenure-legend">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-6 px-3.5 py-2 text-xs font-bold uppercase tracking-[0.15em] text-[#4b4e63]">
        Tenure mix <ChevronDown size={13} className={open ? "" : "rotate-180"} />
      </button>
      {open && (
        <div className="px-3.5 pb-3 space-y-1.5">
          {counts.bands.map((b) => (
            <div key={b.label} className="flex items-center gap-2 text-xs font-semibold">
              <span className="w-3 h-3 rounded" style={{ background: b.color }} />
              <span className="text-[#4b4e63]">{b.label}</span>
              <span className="ml-auto font-black">{b.count}</span>
            </div>
          ))}
          {counts.missing > 0 && (
            <div className="flex items-center gap-2 text-xs font-semibold">
              <span className="w-3 h-3 rounded" style={{ background: GREY }} />
              <span className="text-[#4b4e63]">DOJ missing</span>
              <span className="ml-auto font-black">{counts.missing}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
